import { Anchor, Box, Flex, Group, Text } from '@mantine/core'
import CardBody from './CardBody'
import { SourceIcon } from '../../../../utils/SourceIcon'
import moment from 'moment'
import Property from '../../../common/Property'
import { IconCalendarEvent } from '@tabler/icons'
import {useFields} from "../../../../hooks/useFields";
import { resolveEvidenceDisplayOrigin } from "../../../../utils/evidence/evidenceDisplayOrigin";

const UpperScroller = ({
  chosenEvidence,
  loadEvidence: propLoadEvidence,
  isLoadingMl = false
}:{
  chosenEvidence: any;
  loadEvidence?: () => void;
  isLoadingMl?: boolean;
}) => {
  const { gtmAppsConfiguration } = useFields();
  // Prefer cxItem (conversation) for the "Go To <conversation>" anchor; if absent
  // but the evidence is linked to an opportunity, surface the opportunity link.
  const cxchosenEvidence = chosenEvidence?.cxItem || chosenEvidence?.opportunity;
  const displayOrigin = resolveEvidenceDisplayOrigin(chosenEvidence);

  return (
    <Box>
      <Box px="35px" mt="28px">
        <CardBody item={chosenEvidence} loadEvidence={propLoadEvidence} isLoadingMl={isLoadingMl} />
      </Box>
      {chosenEvidence?.gtmCommittedDate && gtmAppsConfiguration?.gtmCommittedDate?.enabled && 
        <Group mt="sm" px="35px">
          <Property
            bg="#fff"
            key="gtmCommittedDate"
            label={gtmAppsConfiguration?.gtmCommittedDate?.label}
            text={moment(chosenEvidence.gtmCommittedDate).format(gtmAppsConfiguration?.gtmCommittedDate?.dateDisplayFormat || "MMMM D, YYYY")}
            Icon={() => <IconCalendarEvent size={16} />}
            withBorder
          />
        </Group>}
      <Box mb="8px" px="40px">
        {cxchosenEvidence && (
          <Group mt={"md"}>
            {(chosenEvidence?.cxItem || chosenEvidence?.opportunity) && (
              <Box>
                <Flex mb="5px">
                  {displayOrigin ? (
                    <SourceIcon sourceName={displayOrigin} height={15} width={15} />
                  ) : null}
                  <Text ml={8} fz="xs" sx={{ textTransform: "capitalize" }}>
                    {displayOrigin}
                    {cxchosenEvidence?.link && (
                      <Anchor
                        ml="lg"
                        mt={"md"}
                        size={"xs"}
                        component={"a"}
                        target={"_blank"}
                        href={cxchosenEvidence?.link}
                      >
                            Go To {cxchosenEvidence?.originId}
                      </Anchor>
                    )}
                  </Text>
                </Flex>
              </Box>
            )}
          </Group>
        )}
        {!cxchosenEvidence && chosenEvidence?.origin && chosenEvidence?.link && (
          <Group mt={"md"}>
            {displayOrigin && (
              <SourceIcon sourceName={displayOrigin} height={15} width={15} />
            )}
            <Text fz="sm" sx={{ textTransform: "capitalize" }}>
              {displayOrigin || "bagel"}
              {chosenEvidence?.updatedAt && (
                <Text ml="lg" size="xs" c="dimmed" span tt={"lowercase"}>
                  {moment(new Date(chosenEvidence?.updatedAt)).fromNow()}
                </Text>
              )}
              {chosenEvidence?.link && (
                <Anchor
                  ml="lg"
                  mt={"md"}
                  size={"sm"}
                  component={"a"}
                  target={"_blank"}
                  href={chosenEvidence?.link}
                >
                      Go To {chosenEvidence?.chosenEvidenceKey || chosenEvidence?.originId}
                </Anchor>
              )}
            </Text>
          </Group>
        )}
      </Box>
    </Box>
  )
}

export default UpperScroller